import isEqual from 'lodash/isEqual';

import { BillToDetails } from '@rygen/rygen-ui/model';

import { EmbeddableLocation } from '../EmbeddableLocation';

export class OrderBillTo {
  id?: number;
  location: EmbeddableLocation = new EmbeddableLocation();
  billToDetails: BillToDetails = new BillToDetails();

  readonly isOrderBillTo: true = true;
  static emptyBillTo = new OrderBillTo();

  constructor(opts?: Partial<OrderBillTo>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.location != null) {
      this.location = new EmbeddableLocation(opts.location);
    }
    if (opts?.billToDetails != null) {
      this.billToDetails = new BillToDetails(opts.billToDetails);
    }
  }

  static isOrderBillTo(billTo: unknown): billTo is OrderBillTo {
    return !!billTo && (billTo as OrderBillTo).isOrderBillTo === true;
  }

  get isEmpty() {
    return isEqual(this, OrderBillTo.emptyBillTo);
  }
}
